import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import PlusArticle from '../views/PlusArticle.vue'
import HcfmArticle from '../views/HcfmArticle.vue'
import GscbArticle from '../views/GscbArticle.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/plusarticle/:id',
    name: 'plusarticle',
    component: PlusArticle,
  },
  {
    path: '/hcfmarticle/:id',
    name: 'hcfmarticle',
    component: HcfmArticle,
  },
  {
    path: '/article/:id',
    name: 'article',
    component: GscbArticle,
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
